import { Link } from "react-router-dom";
import { getTableFormattedDate } from "../../../helpers/date-time-helper";
import { ColumnDef, createColumnHelper } from "@tanstack/table-core";
import { TDevice } from "../../../common/types";

type TableDevices = Pick<TDevice, 'serialNumber' | 'type' | 'machineName' | 'created' | 'lastActive'>
type TValue = string | number;

const columnHelper = createColumnHelper<TableDevices>();

export const COLUMNS: ColumnDef<TableDevices, TValue>[] = [
    columnHelper.accessor<'serialNumber', string>('serialNumber', {
        id: "serialNumber",
        header: "Serial #",
        enableColumnFilter: false,
        cell: (props) => (
            <Link to={`${props.getValue()}`}>
                {props.getValue()}
            </Link>
        ),
    }),
    columnHelper.display({
        id: 'type',
        header: 'Machine Type',
        enableColumnFilter: false,
        cell: props => props.row.original.type,
    }),
    columnHelper.display({
        id: 'machineName',
        header: 'Name',
        enableColumnFilter: false,
        cell: props => props.row.original.machineName,
    }),
    columnHelper.accessor<'created', string>('created', {
        id: 'created',
        header: 'Date Added',
        enableColumnFilter: false,
        cell: (cellProps) => getTableFormattedDate(cellProps.getValue()),
    }),
    columnHelper.accessor<'lastActive', string>('lastActive', {
        id: 'lastActive',
        header: 'Last Active',
        enableColumnFilter: false,
        cell: (cellProps) => getTableFormattedDate(cellProps.getValue()),
    }),
];
